export function extractUrlFromInput(input) {
  if (!input) return "";
  const trimmed = input.trim();
  const iframeSrcMatch = trimmed.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (iframeSrcMatch && iframeSrcMatch[1]) {
    return iframeSrcMatch[1];
  }
  return trimmed;
}

export function parseVideoUrl(rawInput) {
  if (!rawInput || typeof rawInput !== "string") {
    return {
      platform: "unknown",
      embedUrl: "",
      originalUrl: "",
      cleanUrl: "",
      isValid: false,
      platformTitle: "Unknown"
    };
  }
  const rawUrl = extractUrlFromInput(rawInput);
  let url = rawUrl.trim();
  if (!/^https?:\/\//i.test(url) && !url.startsWith("data:") && !url.startsWith("blob:")) {
    url = "https://" + url;
  }
  const isYouTube = /(?:youtube\.com|youtu\.be)/i.test(url);
  if (isYouTube) {
    let videoId = "";
    const youtuBeMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/i);
    if (youtuBeMatch && youtuBeMatch[1]) {
      videoId = youtuBeMatch[1];
    }
    if (!videoId) {
      const shortsMatch = url.match(/\/shorts\/([a-zA-Z0-9_-]{11})/i);
      if (shortsMatch && shortsMatch[1]) {
        videoId = shortsMatch[1];
      }
    }
    if (!videoId) {
      const embedMatch = url.match(/\/embed\/([a-zA-Z0-9_-]{11})/i);
      if (embedMatch && embedMatch[1]) {
        videoId = embedMatch[1];
      }
    }
    if (!videoId) {
      const liveMatch = url.match(/\/live\/([a-zA-Z0-9_-]{11})/i);
      if (liveMatch && liveMatch[1]) {
        videoId = liveMatch[1];
      }
    }
    if (!videoId) {
      const vParamMatch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/i);
      if (vParamMatch && vParamMatch[1]) {
        videoId = vParamMatch[1];
      }
    }
    if (videoId) {
      return {
        platform: "youtube",
        videoId,
        embedUrl: `https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1`,
        thumbnailUrl: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        originalUrl: rawInput,
        cleanUrl: `https://www.youtube.com/watch?v=${videoId}`,
        isValid: true,
        platformTitle: "YouTube Video"
      };
    }
  }
  const isFacebook = /(?:facebook\.com|fb\.watch|fb\.gg)/i.test(url);
  if (isFacebook) {
    let cleanFbUrl = url;
    if (url.includes("facebook.com/plugins/video.php")) {
      const hrefParam = url.match(/href=([^&]+)/i);
      if (hrefParam && hrefParam[1]) {
        try {
          cleanFbUrl = decodeURIComponent(hrefParam[1]);
        } catch {
          cleanFbUrl = hrefParam[1];
        }
      }
    }
    const fbEmbedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(cleanFbUrl)}&show_text=false&width=734`;
    return {
      platform: "facebook",
      embedUrl: fbEmbedUrl,
      originalUrl: rawInput,
      cleanUrl: cleanFbUrl,
      isValid: true,
      platformTitle: "Facebook Video",
      thumbnailUrl: void 0
    };
  }
  const vimeoRegex = /(?:vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+))/i;
  const vimeoMatch = url.match(vimeoRegex);
  if (vimeoMatch && vimeoMatch[3]) {
    const videoId = vimeoMatch[3];
    return {
      platform: "vimeo",
      videoId,
      embedUrl: `https://player.vimeo.com/video/${videoId}`,
      originalUrl: rawInput,
      cleanUrl: `https://vimeo.com/${videoId}`,
      isValid: true,
      platformTitle: "Vimeo Video"
    };
  }
  if (url.startsWith("data:video/") || url.startsWith("blob:") || /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(url)) {
    return {
      platform: "html5",
      embedUrl: url,
      originalUrl: rawInput,
      cleanUrl: url,
      isValid: true,
      platformTitle: "MP4 / HTML5 Video"
    };
  }
  const looksLikeUrl = Boolean(url.length > 8 && /^https?:\/\//i.test(url));
  return {
    platform: looksLikeUrl ? "html5" : "unknown",
    embedUrl: url,
    originalUrl: rawInput,
    cleanUrl: url,
    isValid: looksLikeUrl,
    platformTitle: looksLikeUrl ? "Web Video" : "Unknown"
  };
}

export function isVideoUrl(rawUrl) {
  if (!rawUrl) return false;
  const lower = rawUrl.toLowerCase();
  return lower.includes("youtube.com") || lower.includes("youtu.be") || lower.includes("facebook.com") || lower.includes("fb.watch") || lower.includes("vimeo.com") || lower.startsWith("data:video/") || lower.startsWith("blob:") || /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(lower);
}

const mediaExports = {
  extractUrlFromInput,
  parseVideoUrl,
  isVideoUrl
};

export default mediaExports;
